import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SharedModule } from '../shared.module';

@Component({
  selector: 'app-terms-and-condition',
  imports: [SharedModule],
  templateUrl: './terms-and-condition.component.html',
  styleUrl: './terms-and-condition.component.scss',
})
export class TermsAndConditionComponent {
  dialogRef = inject(MatDialogRef<TermsAndConditionComponent>, {
    optional: true,
  });
  data = inject(MAT_DIALOG_DATA, { optional: true });

  mode: 'dialog' | 'normal' = this.data?.mode ?? 'normal';

  onAgreed(): void {
    if (this.mode === 'dialog' && this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
